import { render } from "./ImgWrapper.vue?vue&type=template&id=998b5b00"
import script from "./ImgWrapper.vue?vue&type=script&lang=js"
export * from "./ImgWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__